import { tv } from 'tailwind-variants'

export const menuItems = tv({
  base: 'group mt-10 flex flex-col gap-4 font-bold uppercase xl:mt-0 xl:flex-row xl:items-center xl:space-x-2',
  variants: {
    openMenu: {
      true: 'visible',
      false: 'hidden'
    }
  }
})
